<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="notes"
      loading-text="Cargando... Por favor espere"
      no-data-text="No hay registro"
      no-results-text="Lo sentimos no hay registro para su busqueda, intente con otro"
      class="my-2"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2" @click="addNote()">
            Agregar
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.created_at`]="item">
        {{ item.item.created_at.substr(0, 10) }}
      </template>
      <template v-slot:[`item.user_id`]="item">
        {{
          item.item.user_id == item.item.create_by
            ? "COLABORADOR"
            : "ADMINISTRADOR"
        }}
      </template>
    </v-data-table>

    <v-dialog v-model="dialogNote" width="500" persistent>
      <v-card>
        <v-card-title> Agregar Nota </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-textarea
            label="Nota o observación"
            v-model="model.note"
          ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="cancel()"> Cancelar </v-btn>
          <v-btn color="primary" text @click="agree()"> Aceptar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { SET_ALERT } from "@/store/alert";
export default {
  name: "NotesShow",
  props: {
    notes: {
      required: true,
    },
    owner: {
      required: true,
    },
    type: {
      required: true,
    },
    report: {
      required: false,
    },
    bill: {
      required: false,
    },
  },
  data: () => ({
    dialogNote: false,
    headers: [
      { text: "Fecha", value: "created_at", filterable: false },
      {
        text: "Nota",
        align: "start",
        filterable: false,
        value: "note",
      },
      { text: "Usuario", value: "user_id", filterable: false },
    ],
    model: {
      note: "",
    },
  }),
  methods: {
    addNote() {
      this.dialogNote = true;
    },
    agree() {
      this.model.user_id = this.owner;
      if (this.model.note == "") {
        this.$store.commit(SET_ALERT, {
          message: "Debe agregar la nota",
          type: "red",
        });
        return;
      }
      this.model.type = this.type;
      if (this.report) {
        this.model.report_id = this.report;
      }
      if (this.bill) {
        this.model.bill_id = this.bill;
      }
      this.$store.dispatch("createNote", this.model);
      this.cancel();
    },
    cancel() {
      this.dialogNote = false;
      this.model.note = "";
    },
  },
};
</script>
